<template>
  <v-file-input
    @change="fileChanged"
    show-size
    label="Файл"
    v-model="file"
  ></v-file-input>
</template>

<script>
//import { uploader } from "@/api/media";
import { getToken } from "@/libs/util";
import Axios from "axios";
//import Cookies from "js-cookie";

export default {
  name: "simpleUploader",
  props: {
    folderId: {
      type: Number,
      default: () => null
    },
    boxId: {
      type: Number,
      default: () => 0
    },
    objectTypeId: {
      type: Number,
      default: () => 0
    },
    mode: {
      type: Number,
      default: () => 0
    },
    objectId: {
      type: String,
      default: () => "0"
    }
  },
  data() {
    return {
      file: null,
      baseURL: "https://mobcore.gosmart.mn/"
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.baseUrl != undefined &&
      this.$store.state.app.activeGroup.baseUrl != ""
    ) {
      this.baseURL = this.$store.state.app.activeGroup.baseUrl;
    }
  },
  methods: {
    fileChanged(e) {
      if (e != undefined) {
        const config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        let fd = new FormData();
        fd.append("file", e);
        return Axios.post(
          this.baseURL +
            "core/uploader?folderId=-999&boxId=0&objectTypeId=6&objectId=0&mode=0&token=" +
            getToken(),
          fd,
          config
        ).then(res => {
          this.$emit("on-success", res.data.data);
        });
      }
    }
  }
};
</script>
